export default function(http) {
  return {
      queryByPage(data){
        return http.json({
          url: `/template/tag/query`,
          data
        });
      },

      save(data) {
          return http.json({
              url: '/template/tag/save',
              data
          })
      },
      getInfo(data) {
          return http.json({
              url: `/template/tag/get?id=${data.id}`
          })
      },
      /**
       * 删除版本
       * @param data
       * @return {*}
       */
      remove(data) {
          return http.json({
              url: `/template/tag/delete?id=${data[0].id}`,
              data
          })
      },
      list(){
          return http.json({
              url: `/template/tag/list`,
          })
      },
      handleIsTop(data){
          return http.json({
            url: `/template/tag/update`,
            data
        })
      }
  };
}



// WEBPACK FOOTER //
// ./src/configure/http/api/tag.js